module.exports = __webpack_public_path__ + "img/tool-square.c3126e36.svg";